import { memo } from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { CheckCircle2 } from "lucide-react";

const PreviewSectionCard = memo(({ title, data }) => {
  return (
    <Card sx={{ mb: 3, border: "1px solid #e5e7eb" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: "#1f2937",
            mb: 2,
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CheckCircle2 style={{ fontSize: "20px", color: "#059669" }} />
          {title}
        </Typography>

        <Grid container spacing={2}>
          {Object.entries(data).map(([key, value]) => {
            if (!value && value !== 0) return null;
            return (
              <Grid item xs={12} sm={6} key={key}>
                <Box
                  sx={{
                    p: 1.5,
                    backgroundColor: "#f9fafb",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "#6b7280",
                      fontWeight: 600,
                      textTransform: "capitalize",
                      mb: 0.5,
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1").trim()}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: "#1f2937",
                      wordBreak: "break-word",
                    }}
                  >
                    {value}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
});

export default PreviewSectionCard;
